import { Tooltip, Typography } from "@mui/material";


export default function CustomToolTip({ tooltip, children, placement }) {
    return (
        <Tooltip title={<Typography variant="subtitle2">{tooltip}</Typography>} placement={placement}>
            {children}
        </Tooltip>
    );
}